import React from 'react';

import styled from '@emotion/styled';

import { disabledColor, primaryColor, unit } from '@zego/theme';

import View from '@zego/components/atoms/View';

const Banner = styled(View)({
  backgroundColor: disabledColor(2),
  height: unit(12),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: '5%',
});

export default function MoreInformation(): JSX.Element {
  return (
    <Banner>
      <h3>
        For more information and FAQs visit our{' '}
        <a
          href="https://support.zego.com/s/"
          css={{ textDecoration: 'none', color: primaryColor(9) }}
        >
          support
        </a>{' '}
        page.
      </h3>
    </Banner>
  );
}
